import Proptypes from 'prop-types'
import { useRef, useEffect } from 'react'
import {
  BeforeAfterContainer,
  StyledBeforeAfterContainer,
} from 'components/BeforeAfter/styles'
import ReactBeforeSliderComponent from 'react-before-after-slider-component'
import 'react-before-after-slider-component/dist/build.css'

const BeforeAfter = ({ part }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isDragging = useRef(false)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleTouchMove = (e: TouchEvent) => {
      if (isDragging.current) e.preventDefault()
    }

    container.addEventListener('touchmove', handleTouchMove, { passive: false })
    return () => container.removeEventListener('touchmove', handleTouchMove)
  }, [])

  const beforeUrl = part.before?.url || part.beforeOriginal?.url || '';
  const afterUrl = part.after?.url || part.afterOriginal?.url || '';

  return (
    <StyledBeforeAfterContainer>
      <BeforeAfterContainer
        ref={containerRef}
        onPointerDown={() => { isDragging.current = true }}
        onPointerUp={() => { isDragging.current = false }}
        onPointerLeave={() => { isDragging.current = false }}
      >
        <ReactBeforeSliderComponent
          firstImage={{ imageUrl: afterUrl, alt: 'Before image' }}
          secondImage={{ imageUrl: beforeUrl, alt: 'After image' }}
          currentPercentPosition={part.separator?.position}
          delimiterColor={part.separator?.color}
        />
      </BeforeAfterContainer>
      {part.legend && <legend>{part.legend}</legend>}
    </StyledBeforeAfterContainer>
  )
};

BeforeAfter.propTypes = {
  part: Proptypes.object,
  partIndex: Proptypes.number,
}

export default BeforeAfter